module.exports = __webpack_public_path__ + "img/items_alert.91383f89.svg";